<ng-template #modal
             let-modal>
  <div class="modal-content py-2h">
    <div class="row justify-content-center">
      <div class="col-11 col-lg-10">
        <div class="d-flex justify-content-end">
          <button (click)="closeModal()"
                  type="button"
                  class="btn-close"
                  data-dismiss="modal"
                  aria-label="Close">
          </button>
        </div>

        <h2 class="mb-1h fs-42 text-info">
          Descubra o que podemos fazer para o seu negócio.
        </h2>
        <form [formGroup]="formGroup"
              class="needs-validation"
              novalidate>
          <fieldset>
            <div class="mb-1">
              <label for="name"
                     class="sr-only">
                Nome Completo
              </label>
              <input type="text"
                     class="form-control"
                     formControlName="nomeCompleto"
                     placeholder="Nome Completo"
                     [ngClass]="{'is-invalid': validaCampo(formGroup,'nomeCompleto')}">
              <ng-container *ngIf="getCampo(formGroup,'nomeCompleto').errors?.required">
                <span class="invalid-feedback">
                  Por favor, preencha o campo Nome Completo
                </span>
              </ng-container>
            </div>
            <div class="mb-1">
              <label for="e-mail"
                     class="sr-only">
                E-mail
              </label>
              <input type="email"
                     class="form-control"
                     formControlName="email"
                     placeholder="E-mail"
                     [ngClass]="{'is-invalid': validaCampo(formGroup,'email')}">
              <ng-container *ngIf="getCampo(formGroup,'email').errors?.required">
                <span class="invalid-feedback">
                  Por favor, preencha o campo E-mail
                </span>
              </ng-container>
            </div>
            <div class="mb-1">
              <label for="tel"
                     class="sr-only">
                Telefone
              </label>
              <input type="tel"
                     class="form-control"
                     formControlName="telefone"
                     mask="(00) 0000-0000||(00) 00000-0000"
                     placeholder="Celular"
                     [ngClass]="{'is-invalid': validaCampo(formGroup,'telefone')}">
              <ng-container *ngIf="getCampo(formGroup,'telefone').errors?.required">
                <span class="invalid-feedback">
                  Por favor, preencha o campo Telefone
                </span>
              </ng-container>
            </div>
          </fieldset>
          <div class="mb-1">
            <div class="custom-control custom-checkbox">
              <input type="checkbox"
                     class="form-check-input"
                     id="politica-privacidade-modal"
                     formControlName="politicaPrivacidade"
                     [ngClass]="{'is-invalid': validaCampo(formGroup,'politicaPrivacidade')}">
              <label class="custom-control-label text-light"
                     for="politica-privacidade-modal">
                Autorizo o processamento dos meus dados pela
                Rodobens para o
                envio de informações comerciais personalizadas,
                inclusive
                preparando perfis com base nas informações
                obtidas de acordo
                com as disposições da Politica de Privacidade.
              </label>
              <ng-container *ngIf="getCampo(formGroup,'politicaPrivacidade').errors?.required">
                <span class="invalid-feedback">
                  Por favor, selecione o campo Política de privacidade
                </span>
              </ng-container>
            </div>
          </div>
          <div class="row justify-content-end">
            <div class="col-auto">
              <button (click)="enviar();"
                      type="submit"
                      class="btn btn-block btn-info mb-2">
                Enviar
              </button>
            </div>
          </div>
          <p class="text-light">
            Protegemos sua privacidade: não utilizamos seus dados
            para enviar qualquer tipo de spam
          </p>
        </form>
      </div>
    </div>
  </div>
</ng-template>
